import { LockIcon } from "@chakra-ui/icons";
import { chakra, Image, Container, Box, Flex, VStack } from "@chakra-ui/react";
import { useDevice } from "@/contexts/DeviceContext";
import { useProfile } from "@/contexts/ProfileContext";
import { makePluralRegex } from "@/utils/string";

export const SectionTitle = ({ canBeLocked, title, count }) => {
  const isLocked = useProfile().isLocked && canBeLocked;

  return (
    <chakra.h2
      border="0.125rem solid black"
      width="min-content"
      whiteSpace="nowrap"
      shadow="-0.3rem 0.3rem black"
      transform="auto"
      translateY="-50%"
      bg="white"
      borderRadius={10}
      fontFamily="heading"
      px={4}
    >
      {isLocked && <LockIcon w={7} mr={2} />}
      {count !== undefined && `${count} `}
      {count !== undefined ? makePluralRegex(title, count) : title}
    </chakra.h2>
  );
};

export const SectionContent = ({ whenLockedImage, children }) => {
  const isLocked = useProfile().isLocked && !!whenLockedImage;
  if (isLocked) {
    return (
      <Image
        draggable={false}
        alt="Profile is locked"
        src={`/images/profile/${whenLockedImage}.png`}
      />
    );
  } else {
    return children;
  }
};

export const SectionColumn = (props) => (
  <Flex w="100%" flexDir="column" align="center" {...props} />
);

export const Section = ({ children, ...rest }) => {
  const { isMobile } = useDevice();

  if (isMobile && children.length > 0) {
    // Divide it into multiple sections as opposed to side-by-side sections
    return children
      .filter((child) => !!child) // Remove "undefined" and "false" values from the array
      .map((child, i) => (
        <Section key={i} {...rest}>
          {child}
        </Section>
      ));
  } else {
    return (
      <Box borderTop="0.5rem solid black" {...rest}>
        <Container>
          <Flex justifyContent="center" gap={20} pb={20}>
            {children}
          </Flex>
        </Container>
      </Box>
    );
  }
};
